module.exports = __webpack_public_path__ + "img/btm.c9cc839d.svg";